import { getById } from '@/services/api';
import {
  queryCurrent,
  recoveryPassword,
  updatePassword,
  updateProfilePhoto,
} from '@/services/user';

const initialState = {
  currentUser: {},
  recoveryEmailSent: false,
  resetPasswordDone: false,
};

const UserModel = {
  namespace: 'user',
  state: initialState,
  effects: {
    *fetchCurrent({ payload }, { call, put }) {
      try {
        const res = yield call(queryCurrent, payload);
        yield put({ type: 'saveCurrentUser', payload: res });
      } catch (e) {}
    },

    *fetchProfilePicture({ payload }, { call }) {
      try {
        return yield call(getById, { route: 'user/photo', ...payload });
      } catch (e) {}
    },

    *updateProfilePhoto({ payload }, { call }) {
      try {
        const res = yield call(updateProfilePhoto, payload.content);
        return res;
      } catch (e) {
        throw e;
      }
    },

    *forgotPassword({ payload }, { call, put }) {
      const res = yield call(recoveryPassword, payload);
      yield put({ type: 'passwordState', payload: !res });
    },

    *resetPassword({ payload }, { call, put }) {
      try {
        yield call(updatePassword, payload);
        yield put({ type: 'resetState', payload: true });
      } catch (e) {}
    },

    *mailState(o, { put }) {
      yield put({ type: 'passwordState', payload: false });
    },

    *passState({ payload }, { put }) {
      yield put({ type: 'resetState', payload });
    },
  },
  reducers: {
    saveCurrentUser(state, { payload }) {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          ...(payload || {}),
        },
      };
    },

    clearCurrentUser(state) {
      return {
        ...state,
        currentUser: {},
      };
    },

    changeNotifyCount(state = { currentUser: {} }, action) {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          notifyCount: action.payload.totalCount,
          unreadCount: action.payload.unreadCount,
        },
      };
    },

    passwordState(state, { payload }) {
      return {
        ...state,
        recoveryEmailSent: payload,
      };
    },

    resetState(state, { payload }) {
      return {
        ...state,
        resetPasswordDone: payload,
      };
    },
  },
};

export default UserModel;
